import * as React from 'react';

import { assert } from '@gitbook/util-ts';

import { Button, type ButtonProps } from '../Button';
import { useOverlayClose } from '../Overlay';
import { OverlayContext } from './OverlayContext';

export type OverlayCloseButtonProps = ButtonProps;

export function OverlayCloseButton(props: OverlayCloseButtonProps) {
    const context = React.useContext(OverlayContext);
    assert(context !== null, 'OverlayCloseButton must be used within a OverlayRoot.');
    const closeOverlay = useOverlayClose();

    return (
        <Button
            {...props}
            disabled={context.isPending || props.disabled}
            onPress={(event) => {
                props.onPress?.(event);
                closeOverlay();
            }}
        />
    );
}
